import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import { BrowserRouter, createBrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"

import store from "./store"
import Root from "Root"
import { userDetails } from "store/actions/authAction"

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        path: "/dashboard",
        // element: <Home />,
        loader: "homeLoader",
      },
    ],
  },
])

const { Login: { isLoggedIn } = {} } = store.getState() || {}

if (isLoggedIn) {
  store.dispatch(userDetails())
}

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter>
        <App router={router} />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
)
